import { FC, ReactNode } from 'react';

import styles from './MortgageRow.module.scss';

interface DocumentRowProps {
  children: ReactNode;
}

const MortgageRow: FC<DocumentRowProps> = ({ children }) => {
  return <div className={styles.row}>{children}</div>;
};

export default MortgageRow;
